module.exports = __webpack_public_path__ + "static/media/system-oto-modulesE-img.58ad2749.png";